import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { ThumbnailCarouselType } from './BrandingSettings.Contract';

export const defaultLogo = {
	name: 'default-logo',
	url: `${BootstrapContext.baseCdnUrl}/img/vbrick-logo.png`
};

export const defaultFavicon = {
	name: 'default-favicon',
	url: `${BootstrapContext.baseCdnUrl}${BootstrapContext.defaultFavicon}`,
	ecdnUrl: `${BootstrapContext.baseCdnUrl}/shared/img/favicon.ico`,
	scaledIcons: BootstrapContext.defaultScaledFavicons
};

export const defaultSystemTitle = {
	title: BootstrapContext.defaultSystemTitle
};

export const defaultFont = {
	name: 'Open Sans',
	url: `${BootstrapContext.baseCdnUrl}/font/OpenSans-Regular.woff`
};

export const defaultColors = {
	accentColor: '#108dda',
	accentFontColor: '#fff',
	featuredVideoBackgroundColor: '#141414',
	primaryColor: '#141414',
	primaryFontColor: '#fff',
	channelFont: '#fff'
};

export const defaultThumbnailCarouselSettings = {
	carouselType: ThumbnailCarouselType.Left,
	overlayColor: '#000',
	overlayOpacity: 50
};

export const defaultHeaderColors = {
	background: '#1a1a1a',
	font: '#fff'
};

export const defaultBannerHeight = 6;

export const defaultBackgroundImageOpacity = 50;

export const defaultHelpUri = 'https://revdocs.vbrick.com/docs';
export const publicPortalAccessHelpUri = `${defaultHelpUri}/customize-your-public-landing-page`;
